import { Ad } from '@/__generated_graphql__/graphql';
import { CardStatus } from '@/constants/common';
import { CardAd } from '@/types';

export const transformAdsToCards = (ads: Ad[]): CardAd[] =>
  ads.map(
    ({
      id,
      name: title,
      positionName: subtitle,
      updatedAt,
      createdAt,
      bumpedAt,
      location,
      education,
      experience,
      daysLeft,
      logo: image,
      salaryFrom,
      salaryTo,
      status,
      isFeatured,
      isBumped,
      isBookmarked,
      isMine,
      paidServices,
      __typename
    }): CardAd => ({
      id,
      title,
      subtitle,
      createdAt,
      updatedAt,
      bumpedAt,
      location,
      education,
      experience,
      salaryFrom,
      salaryTo,
      status: status as CardStatus,
      image,
      daysLeft,
      isFeatured,
      isBumped,
      isBookmarked,
      isMine,
      isDeactivated: status === CardStatus.EXPIRED,
      paidServices,
      __typename
    })
  );
